import { render, staticRenderFns } from "./OrderSearch.vue?vue&type=template&id=4bb2352b&scoped=true&"
import script from "./OrderSearch.vue?vue&type=script&lang=ts&"
export * from "./OrderSearch.vue?vue&type=script&lang=ts&"
import style0 from "./OrderSearch.vue?vue&type=style&index=0&id=4bb2352b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2352b",
  null
  
)

export default component.exports